// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e5faf9;
  padding: 16px;
  position: relative;
}
.back-arrow{
  position: absolute;
  top: 20px;
  left: 20px;
  border: none;
  padding: 10px;
  border-radius: 6px;
  background-color: transparent;
  cursor: pointer;
  transition: background-color 0.2s;
}

.back-arrow:hover{
  background-color: #f9fafb;
}

.login-card {
  position: relative;
  background: white;
  border-radius: 16px;
  padding: 48px;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.logo-container {
  margin-bottom: 24px;
}

.company-logo {
  width: 48px;
  height: 48px;
  color: #0d9488;
}

.welcome-text {
  font-size: 24px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 8px 0;
}

.subtitle-text {
  font-size: 16px;
  color: #374151;
  margin: 0 0 4px 0;
}

.instruction-text {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 32px 0;
}

.input-login-container{
  width: 100%;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: white;
  color: #374151;
  font-size: 14px;
  margin-bottom: 10px;
  transition: all 0.2s ease-in-out;
  outline: none;
  box-sizing: border-box;
}

.input-login-container::placeholder {
  color: #9ca3af;
  font-weight: 400;
}

.input-login-container:focus {
  border-color: #0d9488;
  box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.1);
}

.input-login-container:hover {
  border-color: #d1d5db;
}


.office-signin-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: white;
  color: #374151;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.office-signin-button:hover {
  background-color: #f9fafb;
}

.microsoft-logo {
  width: 20px;
  height: 20px;
}

.divider {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 24px 0;
}

.divider-line {
  flex: 1 1;
  height: 1px;
  background-color: #e5e7eb;
}

.divider-text {
  font-size: 14px;
  color: #6b7280;
  white-space: nowrap;
}

.password-input-container {
  position: relative;
  width: 100%;
}

.password-toggle-btn {
  position: absolute;
  right: 12px;
  top: 40%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  outline: none;
}

.password-toggle-btn:hover {
  color: #4b5563;
  background-color: #f9fafb;
}

.password-toggle-btn:focus {
  color: #0d9488;
}

.password-toggle-btn:active {
  color: #0f766e;
  background-color: #f0fdfa;
  transform: translateY(-50%) scale(0.95);
}

.password-toggle-btn svg {
  transition: all 0.2s ease-in-out;
}

.password-instruction{
  font-size: 10px;
  color: #374151;
}

/* Reset Password Button Styles */
.password-reset {
  background: none;
  border: none;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 0;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  outline: none;
  border-radius: 4px;
  position: relative;
  align-self: flex-end;
}

.password-reset:hover {
  color: #4b5563;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.password-reset:focus {
  color: #059669;
  outline: 2px solid #10b981;
  outline-offset: 2px;
}

.password-reset:active {
  color: #047857;
  transform: translateY(1px);
}

.reset-buttons{
  width: 100%;
  display: flex;
  gap: 10px;
}

.credentials-button {
  width: 100%;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: white;
  color: #374151;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.credentials-button:hover {
  background-color: #f9fafb;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .login-card {
    padding: 32px 24px;
  }
   .password-toggle-btn {
    right: 10px;
  }
  
  .input-login-container {
    padding-right: 44px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/login/login.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gCAAgC;EAChC,8EAA8E;EAC9E,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;EACpB;GACC;IACC,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".login-container {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #e5faf9;\n  padding: 16px;\n  position: relative;\n}\n.back-arrow{\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  border: none;\n  padding: 10px;\n  border-radius: 6px;\n  background-color: transparent;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.back-arrow:hover{\n  background-color: #f9fafb;\n}\n\n.login-card {\n  position: relative;\n  background: white;\n  border-radius: 16px;\n  padding: 48px;\n  width: 100%;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.logo-container {\n  margin-bottom: 24px;\n}\n\n.company-logo {\n  width: 48px;\n  height: 48px;\n  color: #0d9488;\n}\n\n.welcome-text {\n  font-size: 24px;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 8px 0;\n}\n\n.subtitle-text {\n  font-size: 16px;\n  color: #374151;\n  margin: 0 0 4px 0;\n}\n\n.instruction-text {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0 0 32px 0;\n}\n\n.input-login-container{\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: white;\n  color: #374151;\n  font-size: 14px;\n  margin-bottom: 10px;\n  transition: all 0.2s ease-in-out;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.input-login-container::placeholder {\n  color: #9ca3af;\n  font-weight: 400;\n}\n\n.input-login-container:focus {\n  border-color: #0d9488;\n  box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.1);\n}\n\n.input-login-container:hover {\n  border-color: #d1d5db;\n}\n\n\n.office-signin-button {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: white;\n  color: #374151;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.office-signin-button:hover {\n  background-color: #f9fafb;\n}\n\n.microsoft-logo {\n  width: 20px;\n  height: 20px;\n}\n\n.divider {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin: 24px 0;\n}\n\n.divider-line {\n  flex: 1;\n  height: 1px;\n  background-color: #e5e7eb;\n}\n\n.divider-text {\n  font-size: 14px;\n  color: #6b7280;\n  white-space: nowrap;\n}\n\n.password-input-container {\n  position: relative;\n  width: 100%;\n}\n\n.password-toggle-btn {\n  position: absolute;\n  right: 12px;\n  top: 40%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s ease-in-out;\n  outline: none;\n}\n\n.password-toggle-btn:hover {\n  color: #4b5563;\n  background-color: #f9fafb;\n}\n\n.password-toggle-btn:focus {\n  color: #0d9488;\n}\n\n.password-toggle-btn:active {\n  color: #0f766e;\n  background-color: #f0fdfa;\n  transform: translateY(-50%) scale(0.95);\n}\n\n.password-toggle-btn svg {\n  transition: all 0.2s ease-in-out;\n}\n\n.password-instruction{\n  font-size: 10px;\n  color: #374151;\n}\n\n/* Reset Password Button Styles */\n.password-reset {\n  background: none;\n  border: none;\n  color: #6b7280;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 8px 0;\n  text-decoration: none;\n  transition: all 0.2s ease-in-out;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  outline: none;\n  border-radius: 4px;\n  position: relative;\n  align-self: flex-end;\n}\n\n.password-reset:hover {\n  color: #4b5563;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.password-reset:focus {\n  color: #059669;\n  outline: 2px solid #10b981;\n  outline-offset: 2px;\n}\n\n.password-reset:active {\n  color: #047857;\n  transform: translateY(1px);\n}\n\n.reset-buttons{\n  width: 100%;\n  display: flex;\n  gap: 10px;\n}\n\n.credentials-button {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: white;\n  color: #374151;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.credentials-button:hover {\n  background-color: #f9fafb;\n}\n\n/* Responsive adjustments */\n@media (max-width: 480px) {\n  .login-card {\n    padding: 32px 24px;\n  }\n   .password-toggle-btn {\n    right: 10px;\n  }\n  \n  .input-login-container {\n    padding-right: 44px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
